/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { JiraCustomizationModalEntrypointProps } from './ui/JiraCustomizationModal.entrypoint.types.tsx';

type CustomisableSidebarModalEntrypointComponent = EntryPointComponent<
	{},
	{},
	JiraCustomizationModalEntrypointProps,
	{}
>;

export const CustomisableSidebarModalEntrypoint: EntryPoint<
	CustomisableSidebarModalEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<CustomisableSidebarModalEntrypointComponent>(
		/* webpackChunkName: "async-jira-navigation-apps-sidebar-nav4-customization-modal" */ './ui/JiraCustomizationModal.tsx',
	),
	getPreloadProps: (props) => ({
		queries: {}, // Need to specify `queries` as it is a mandatory prop
		props,
	}),
});
